import { BaseRouteModel } from 'libs/router/model';
import { JsonMap } from 'libs/types';
import { PagePermission } from '../modules/user_page/types';
import { UserRole } from '../modules/user_role/types';

export class RouteModel<
  T extends { [key: string]: string | number } = never,
  StateT extends JsonMap = never
> extends BaseRouteModel<T, StateT, PagePermission, UserRole> {
  public isPermittedCurrentOnly(permissions: PagePermission[], roles: UserRole[]): boolean {
    return (
      (!this.permission || permissions.includes(this.permission)) &&
      (!this.role || roles.includes(this.role))
    );
  }

  public isPermitted(permissions: PagePermission[], roles: UserRole[]): boolean {
    return (
      this.isPermittedCurrentOnly(permissions, roles) &&
      (!this.parent || this.parent.isPermitted(permissions, roles))
    );
  }

  public findChildrenByPermission(permissions: PagePermission[], roles: UserRole[]) {
    return this.isPermitted(permissions, roles)
      ? this.children.filter(child => child.isPermittedCurrentOnly(permissions, roles))
      : [];
  }

  public getParent(): RouteModel | undefined {
    return this.parent as RouteModel | undefined;
  }
}
